/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import HealthIcon from 'icons/HealthIcon';

const messages = defineMessages({
  title: {id: 'navigation.health-guidance'},
});

const GuidanceItem = () => (
  <RouteLinkItem
    iconBefore={HealthIcon}
    route="midas/students/health/guidance"
    title={messages.title}
  />
);

export default GuidanceItem;
